<template>
  <div class="cab-feed mt-n3 pb-1">
    <div class="feed-header">
      <!-- <feedbar
        @navbar-clicked="$emit('toggle-sidebar')"
        @search-clicked="$emit('search-clicked')"
        @new-note-clicked="$emit('new-note-clicked')"
      /> -->
    </div>
    <div class="content">
      <div
        v-for="note in notes"
        :key="note.id"
      >
        <note-card
          :text="note.text"
          :img="note.img"
        />
        <!-- <div style="height: 10px"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Feedbar from "@/components/Feedbar";
import NoteCard from "@/components/NoteCard";

export default {
  name: "Feed",
  components: {
    Feedbar,
    NoteCard
  },
  computed: {
    notes() {
      return this.$store.getters.getNotes;
    }
  },
  methods: {}
};
</script>

<style scoped>
.content {
  margin-top: 15px;
}
</style>
